import React, { useEffect, useState } from "react";
import { Checkbox } from "./ActivityCheckboxes";
import Button from "../../../../components/form/button";
import Spinner from "../../../../components/form/spinner";
import Actions from "./actions";

export default function FeatureFlags({ _id }) {
    return (
        <>
            <h1>Features</h1>
            <p>
                Update feature on{" "}
                <a
                    href={`https://app.blue-trace.com/${_id}/settings/features`}
                    target="_blank"
                >
                    app.blue-trace.com
                </a>
                .
            </p>
        </>
    );
}
